import type { SpecialArticle } from "./chapters";

export const specialGroups: SpecialArticle["group"][] = ["影评", "幕后", "角色"];

export const specialArticles: SpecialArticle[] = [
  {
    slug: "ring-and-lie",
    group: "影评",
    title: "戒指与谎言的交换",
    subtitle: "一枚小物件如何撑起整部电影的情感重量",
    cover:
      "https://readdy.ai/api/search-image?query=antique%20gold%20ring%20on%20dark%20velvet%20with%20scattered%20jewelry%20tools%2C%20single%20beam%20of%20warm%20light%2C%20deep%20wine%20red%20background%2C%20elegant%20macro%20cinematic%20still%20life%2C%20no%20text&width=1200&height=700&seq=sj-sp-01&orientation=landscape",
    readTime: "6 分钟",
    date: "2026-09-18",
    paragraphs: [
      "在整部电影里，戒指出现的次数并不多，但每一次都恰好踩在关系变化的关键点上。它先是一个任务道具，后来变成一份证明，最后变成一种无法退回的承诺。",
      "有意思的是，影片从不让角色把话说透。观众只能通过手指的停顿、镜子里的倒影和一句随口的解释，去推测这枚戒指究竟意味着什么。",
      "当一件物品同时承载了欺骗与真心，它就不再是道具，而是人物关系的计量器。它越贵重，那些说不出口的部分就越沉重。",
      "所以结局真正让人难受的地方，不是谁输谁赢，而是那枚戒指再也无法被戴回原本的位置。",
    ],
  },
  {
    slug: "three-mahjong-games",
    group: "影评",
    title: "三场牌局：权力如何在桌面流转",
    subtitle: "从座位、出牌和眼神，读懂人物之间的暗战",
    cover:
      "https://readdy.ai/api/search-image?query=overhead%20view%20of%20a%20mahjong%20table%20with%20ivory%20tiles%20and%20a%20porcelain%20teacup%2C%20warm%20amber%20lamp%20light%20in%20a%20dark%20room%2C%20deep%20burgundy%20tablecloth%2C%20cinematic%20top%20down%20composition%2C%20no%20text&width=1200&height=700&seq=sj-sp-02&orientation=landscape",
    readTime: "5 分钟",
    date: "2026-09-12",
    paragraphs: [
      "牌桌是这部电影最聪明的叙事装置之一。它让所有人都有理由坐在一起，也让所有人都有理由不说话。",
      "第一场牌局建立关系，第二场牌局交换信息，第三场牌局则彻底撕开了表面的平衡。座位的变化比台词更早告诉观众，谁在这一轮占了上风。",
      "出牌的节奏也被刻意处理过：有人快，是心虚；有人慢，是计算；有人始终不紧不慢，因为他知道自己不需要赢下这一局。",
      "当镜头从牌面移到人的脸上，观众才意识到真正被观看的从来不是牌，而是每个人努力维持的那副表情。",
    ],
  },
  {
    slug: "adaptation-choices",
    group: "幕后",
    title: "从小说到银幕：改编的取舍",
    subtitle: "文字里的心理描写，如何变成镜头里的沉默",
    cover:
      "https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwritten%20manuscript%20pages%20and%20a%20vintage%20pen%20on%20a%20dark%20wooden%20desk%2C%20warm%20desk%20lamp%20glow%2C%20candle%20and%20smoke%20atmosphere%2C%20cinematic%20still%20life%2C%20no%20text&width=1200&height=700&seq=sj-sp-03&orientation=landscape",
    readTime: "7 分钟",
    date: "2026-08-30",
    paragraphs: [
      "文学可以写“她心里忽然一沉”，电影不行。电影必须找到一个可以被看见的动作，来替代那句心理描写。",
      "于是原著里大量的内心活动，被换成了门的开合、衣服的褶皱、茶水的温度和一个人站在窗前的时间长度。",
      "改编最难的部分不是删减情节，而是决定哪些情绪可以交给演员，哪些必须交给环境。这也是为什么本片的美术与光影几乎承担了半个叙事。",
      "对于熟悉原著的观众来说，这些改动会带来新的解读空间；对于第一次接触故事的观众，它们又足够清晰，不至于迷失。",
    ],
  },
  {
    slug: "set-design-era",
    group: "幕后",
    title: "旗袍、雨夜与弄堂：时代质感从哪来",
    subtitle: "美术、服装与光线的三重协作",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20tailoring%20atelier%20with%20rolls%20of%20silk%20fabric%2C%20mannequin%20in%20a%20red%20cheongsam%2C%20warm%20window%20light%20and%20dust%20in%20the%20air%2C%20deep%20burgundy%20and%20brass%20tones%2C%20cinematic%20interior%2C%20no%20text&width=1200&height=700&seq=sj-sp-04&orientation=landscape",
    readTime: "6 分钟",
    date: "2026-08-22",
    paragraphs: [
      "年代感从来不是靠一两件旧家具堆出来的。它需要一整套一致的逻辑：墙面的旧痕、灯罩的色温、布料在灯下的反光，甚至雨落在不同材质上的声音。",
      "旗袍在这部电影里既是服装，也是语言。剪裁的松紧、颜色的深浅、盘扣的位置，都在替角色说明她此刻的身份与心态。",
      "雨夜则提供了另一种质感：湿漉漉的街面会反光，反光会制造出多余的光源，而这些光源恰好让暗部不再是死黑。",
      "把这些细节拼在一起，观众才会相信故事真的发生在那个年代，而不是一个被布置出来的摄影棚。",
    ],
  },
  {
    slug: "her-last-choice",
    group: "角色",
    title: "她为何在最后一刻改变主意",
    subtitle: "一场关于身份、表演与真心的长跑",
    cover:
      "https://readdy.ai/api/search-image?query=woman%20silhouette%20standing%20by%20a%20rain%20streaked%20window%20in%20a%20dim%20room%2C%20warm%20lamp%20behind%20her%2C%20deep%20wine%20red%20curtains%2C%20melancholic%20cinematic%20composition%2C%20soft%20grain%2C%20no%20text&width=1200&height=700&seq=sj-sp-05&orientation=landscape",
    readTime: "8 分钟",
    date: "2026-08-15",
    paragraphs: [
      "她从一开始就不是一个单纯的角色。她有任务、有同伴、有必须完成的目标，也有一个被反复打磨过的假身份。",
      "问题在于，假身份需要真实的情感来支撑。她要让对方相信，就必须先让自己相信一点点。那一点点，最后变成了无法收回的部分。",
      "所以最后一刻的转变并不是突然的软弱，而是长期压抑之后的必然。她不是忘了任务，而是终于承认自己也是一个人。",
      "这也是这个角色最动人的地方：她做出的选择并不正确，却极其真实。",
    ],
  },
  {
    slug: "hunter-or-prey",
    group: "角色",
    title: "他是猎人，还是猎物",
    subtitle: "双重身份下的猜疑与依赖",
    cover:
      "https://readdy.ai/api/search-image?query=male%20silhouette%20in%20a%20dark%20tailored%20suit%20standing%20in%20a%20doorway%20with%20warm%20backlight%2C%20deep%20charcoal%20and%20amber%20palette%2C%20tense%20film%20noir%20portrait%2C%20cinematic%20shadow%20play%2C%20no%20text&width=1200&height=700&seq=sj-sp-06&orientation=landscape",
    readTime: "7 分钟",
    date: "2026-08-06",
    paragraphs: [
      "他掌握着权力、资源与主动权，看起来是这场博弈里毫无疑问的猎人。但电影不断给出相反的暗示：他也需要有人听他说话。",
      "一个真正无所畏惧的人，不需要反复确认对方是否还在。他的多疑既是职业习惯，也是情感上的不安全感。",
      "当他愿意为一枚戒指停下来的时候，猎人就已经走进了自己设下的陷阱。",
      "这段关系的悲剧性在于，两个人都在用最擅长的方式保护自己，却恰好伤害了对方最在意的部分。",
    ],
  },
];